import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

import { EmptyState } from '../../../chrome/state';
import { Button } from '../../../ui/button';
import { HOME_PATH } from '../../routes/paths';
import { ta } from './messages';
import type { BlockedState } from './schemas';

export type InvitationBlockedProps = {
  state: BlockedState;
  /** Null when the API did not say who sent it: the unavailable preview carries no sender. */
  sender: string | null;
  onDecline?: () => void;
  declining?: boolean;
};

const TITLE_KEYS = {
  EXPIRED: 'blocked.expired',
  WITHDRAWN: 'blocked.withdrawn',
  ACCEPTED: 'blocked.accepted',
  NO_LONGER_VALID: 'blocked.noLongerValid',
} as const;

export function InvitationBlocked(props: InvitationBlockedProps): ReactNode {
  const titleKey = TITLE_KEYS[props.state];
  const description =
    props.state === 'ACCEPTED'
      ? undefined
      : props.sender
        ? ta('blocked.ask', { sender: props.sender })
        : ta('blocked.askUnnamed');

  const action =
    props.state === 'ACCEPTED' ? (
      <Button asChild>
        <Link to={HOME_PATH}>{ta('action.home')}</Link>
      </Button>
    ) : props.state === 'NO_LONGER_VALID' ? (
      <Button type="button" variant="outline" disabled={props.declining} onClick={props.onDecline}>
        {ta('action.decline')}
      </Button>
    ) : undefined;

  return (
    <EmptyState tone="blocked" title={ta(titleKey)} description={description} action={action} />
  );
}
